import React from 'react';
import { FacebookIcon, InstagramIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#E63946] text-white py-2 px-4" data-id="element-290">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-291">
        <div className="flex items-center space-x-4" data-id="element-292">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" aria-label="Facebook" data-id="element-293">
            <FacebookIcon className="h-5 w-5" data-id="element-294" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" aria-label="Instagram" data-id="element-295">
            <InstagramIcon className="h-5 w-5" data-id="element-296" />
          </a>
        </div>
        <div className="flex items-center space-x-6 text-sm" data-id="element-297">
          <a href="tel:2405653357" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-298">
            <PhoneIcon className="h-4 w-4 mr-2" data-id="element-299" />
            240-565-3357
          </a>
          <a href="mailto:judahnursingservices@gmail.com" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-300">
            <MailIcon className="h-4 w-4 mr-2" data-id="element-301" />
            judahnursingservices@gmail.com
          </a>
        </div>
      </div>
    </div>;
}